import { combineReducers } from 'redux';
import contentReducer from './content-reducer';
import userReducer from './user-reducer';
export default combineReducers({
    userReducer,
    contentReducer,
});
